import { Colors } from "../constants/colors";
export var isColorLight = function isColorLight() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var hex = color.replace('#', '');
  if (hex.length === 6) {
    hex = "".concat(hex, "FF");
  }
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  var a = parseInt(hex.substring(6, 8), 16);
  var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b + (255 - a);
  return luma > 165;
};
export var isColorDark = function isColorDark() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return !isColorLight(color);
};
var getColor = function getColor(color) {
  return Colors[color] || color;
};
export var percentToHex = function percentToHex(percent) {
  if (typeof percent !== 'number') {
    throw new Error('percentToHex: a percentage value must be provided.');
  }
  var boundPercent = Math.max(0, Math.min(100, percent));
  var intValue = Math.round(boundPercent / 100 * 255);
  var hexValue = intValue.toString(16);
  return hexValue.padStart(2, '0').toUpperCase();
};
export var applyOpacityToHexColor = function applyOpacityToHexColor(opacity, color) {
  if (typeof opacity !== 'number') {
    throw new Error('applyOpacityToHexColor: a opacity must be provided.');
  }
  if (!color) {
    throw new Error("applyOpacityToHexColor: a color NAME (check constants/colors) or HEX must be provided.");
  }
  return "".concat(getColor(color)).concat(percentToHex(opacity));
};
var darkenColorComponent = function darkenColorComponent(percent, component) {
  return Math.floor(component * (percent / 100));
};
export var darkenHex = function darkenHex(percent, color) {
  if (typeof percent !== 'number') {
    throw new Error('darkenHex: a percent must be provided.');
  }
  if (!color) {
    throw new Error("darkenHex: a color NAME (check constants/colors) or HEX must be provided.");
  }
  var hex = getColor(color).replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  return "#".concat([r, g, b].map(function (component) {
    return darkenColorComponent(percent, component).toString(16).padStart(2, '0').toUpperCase();
  }).join(''));
};
var lightenColorComponent = function lightenColorComponent(percent, component) {
  return Math.floor(component + (255 - component) * (percent / 100));
};
export var lightenHex = function lightenHex(percent, color) {
  if (typeof percent !== 'number') {
    throw new Error('lightenHex: a percent must be provided.');
  }
  if (!color) {
    throw new Error("lightenHex: a color NAME (check constants/colors) or HEX must be provided.");
  }
  var hex = getColor(color).replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  return "#".concat([r, g, b].map(function (component) {
    return lightenColorComponent(percent, component).toString(16).padStart(2, '0').toUpperCase();
  }).join(''));
};